import React, {useState} from 'react'
import Button from '@material-ui/core/Button'
import {Trans} from 'react-i18next'
import messages from '../../../assets/messages'
import {canDownloadPayoutCertificate, downloadPayoutCertificate} from './payoutCertificate'

const PayoutCertificateButton = ({row, className}: {row: any, className?: string}) => {
  const [busy, setBusy] = useState(false)
  const [failed, setFailed] = useState(false)
  if (!canDownloadPayoutCertificate(row)) return null
  const onClick = async () => {
    setBusy(true)
    setFailed(false)
    const ok = await downloadPayoutCertificate(row.id)
    setFailed(!ok)
    setBusy(false)
  }
  return (
    <>
      <Button disableFocusRipple disableRipple variant="text" color="primary" disabled={busy}
        classes={{root: className}} onClick={onClick}>
        <Trans {...messages.downloadPayoutCertificate} />
      </Button>
      {failed && <div role="alert"><Trans {...messages.payoutCertificateDownloadFailed} /></div>}
    </>
  )
}

export default PayoutCertificateButton
